import type { OmitStyles } from "@/styles/tokens.stylex";
import { getAssetsImage } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

export default function PlnIcon({ styleX, ...rest }: OmitStyles<React.ImgHTMLAttributes<HTMLImageElement>>) {
    return (
        <img
            {...rest}
            {...stylex.props(styleX)}
            src={getAssetsImage(process.env.CB_Pln_Icon)}
            alt="Pln icon"
        />
    );
}
